<template>
  <div id="map-navigator" class="map-navigator">
    <topology-map
      :canvasOptions="canvasOptions"
      :maps="$globalData.maps"
      :mapNodeModels="$globalData.mapNodeModels"
      :mapLoad="handleMapLoad"
      :mapReadyUnload="handleMapReadyUnload"
      :nodeClick="handleNodeClick"
      ref="topologyMap"
    >
    </topology-map>

    <!--视频播放器窗口-->
    <video-player-modal v-if="videoPlayerModalOpen" :modalOpen="videoPlayerModalOpen" :streamNodes="activeStreamNodes" :videoOpen="videoPlayerModalVideoOpen" @cancel="handleVideoPlayerModalCancel"></video-player-modal>

    <!--显示数据节点信息-->
    <show-data-node v-if="showDataNodeModalOpen" :modalOpen="showDataNodeModalOpen" :dataNode="currentDataNode" @cancel="handleShowDataNodeModalCancel"></show-data-node>

    <!--事件集合弹窗-->
    <alarm-events-Modal v-if="eventsModalOpen" :modalOpen="eventsModalOpen" @cancel="handleEventsModalCancel"></alarm-events-Modal>

  </div>
</template>

<script type="text/ecmascript-6">
import MapNavigator from './MapNavigator.js'
export default MapNavigator
</script>

<style lang="scss">
@import "MapNavigator";
</style>



// WEBPACK FOOTER //
// src/views/common/mapNavigator/MapNavigator.vue